import Image1 from "../image/bazen/image1.webp";
import Image2 from "../image/bazen/image2.webp";
import Image3 from "../image/bazen/image3.webp";

export const BazenData = [
  {
    id: 1,
    image: Image1,
    alt: "Image bazen 1",
  },
  {
    id: 2,
    image: Image2,
    alt: "Image bazen 2",
  },
  {
    id: 3,
    image: Image3,
    alt: "Image bazen 3",
  },
];
